import React from 'react';

const Toggle = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 32 32"
			className={className}
		>
			<path d="M3.1 10.17h24.98c.48.04.91-.31.96-.79V7.41a.89.89 0 0 0-.96-.79H3.1a.89.89 0 0 0-.96.79v1.97c.05.48.48.83.96.79Zm0 7.87h24.98c.48.04.91-.31.96-.79v-1.97a.89.89 0 0 0-.96-.79H3.1a.89.89 0 0 0-.96.79v1.97c.05.48.48.83.96.79Zm0 7.87h24.98c.48.04.91-.31.96-.79v-1.97a.89.89 0 0 0-.96-.79H3.1a.89.89 0 0 0-.96.79v1.97c.05.48.48.83.96.79Z" />
		</svg>
	);
};

export default Toggle;
